import firebase from 'firebase/compat/app';
import { boot } from 'quasar/wrappers'
import 'firebase/compat/database';
import 'firebase/compat/auth';
import 'firebase/compat/firestore'

const config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  // measurementId: '<measurementId>',
}
let firebaseApp = firebase.initializeApp(config);
let db = firebase.database()
let firestore = firebase.firestore()
let auth = firebase.auth()
firebase.auth().signInAnonymously()
export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$firebase = firebase
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file
})

export { db, firebase, auth, firestore };
